import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRatings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#ratings_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M17.28 12.44a.44.44 0 0 0-.294.769c.063.055.294.312.294.552a.44.44 0 0 1-.44.44.44.44 0 0 0-.293.768c.062.055.293.312.293.552a.44.44 0 0 1-.44.44.44.44 0 0 0-.296.766c.049.045.468.446.208.79a.55.55 0 0 1-.443.204H9.812c-.024-.002-.59-.046-.915-1.02-.41-1.231-.417-2.488-.417-2.495s.026-.79.806-1.961l2.64-3.96A.44.44 0 0 0 12 8.04V6.72c0-.39 0-.44.44-.44.433 0 .88 1.307.88 1.76 0 1.428-.363 1.94-1.191 2.769a.44.44 0 0 0 .311.75h4.84a.44.44 0 0 1 0 .88m-11 1.76c0-1.255.776-2.288 1.075-2.64h1.33l-.131.197c-.927 1.39-.954 2.34-.954 2.444 0 .056.005 1.407.463 2.779q.054.161.116.3H6.823c-.204-.286-.543-1.5-.543-3.08M18.6 12c0-.727-.592-1.32-1.32-1.32h-3.855c.531-.694.775-1.412.775-2.64 0-.466-.458-2.64-1.76-2.64-1.32 0-1.32.96-1.32 1.32v1.187l-1.849 2.774H7.16a.44.44 0 0 0-.311.129c-.06.059-1.449 1.47-1.449 3.39 0 .04.036 3.96 1.32 3.96h2.075c.486.43.974.44 1.005.44h6.069c.456 0 .885-.206 1.145-.552.378-.5.302-1.018.102-1.418.363-.236.604-.645.604-1.11 0-.244-.072-.466-.165-.65a1.32 1.32 0 0 0 .605-1.11c0-.244-.072-.466-.165-.65A1.32 1.32 0 0 0 18.6 12"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="ratings_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRatings;
